import { environment } from '../environments/environment';
import { ROUTE_PATH } from './common/constants';
import { accessGuard } from './common/guards/access.guard';
import { EopRoute } from './common/interfaces';

const maintenanceRoutes: EopRoute[] = [{ path: '' }, { path: '**', redirectTo: '' }];

const mainRoutes: EopRoute[] = [
	{
		path: '',
		loadComponent: () =>
			import('./common/components/layout/layout.component').then((c) => c.LayoutComponent),
		children: [
			{
				path: '',
				pathMatch: 'full',
				canMatch: [accessGuard],
				loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
			},
			{
				title: 'EOP - Invite User',
				path: ROUTE_PATH.inviteUser,
				canMatch: [accessGuard],
				data: {
					access: {
						permissions: ['CanInviteUsers'],
					},
					link: { svgIcon: 'cust-user-add', text: 'Invite user' },
					cache: true,
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/invite-user/invite-user.component').then((c) => c.InviteUserComponent),
			},
			{
				title: 'EOP - Order Lenses',
				path: ROUTE_PATH.placeOrder,
				canMatch: [accessGuard],
				data: {
					config: 'at',
					access: {
						permissions: ['CanCreateOrders'],
					},
					link: { svgIcon: 'cust-lens-add', text: 'Place a lens order' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/place-order/_at-place-order/at-place-order.component').then(
						(c) => c.AtPlaceOrderComponent,
					),
			},
			{
				title: 'EOP - My Orders',
				path: ROUTE_PATH.myOrders,
				canMatch: [accessGuard],
				data: {
					config: 'at',
					access: {
						permissions: ['CanViewOrders'],
					},
					link: { svgIcon: 'cust-lens-check', text: 'My orders' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/my-orders/_at-my-orders/at-my-orders.component').then(
						(c) => c.AtMyOrdersComponent,
					),
			},
			{
				title: 'EOP - Order Lenses',
				path: ROUTE_PATH.placeOrder,
				canMatch: [accessGuard],
				data: {
					config: 'os',
					access: {
						permissions: ['CanCreateOrders'],
					},
					link: { svgIcon: 'cust-lens-add', text: 'Place a lens order' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/place-order/_os-place-order/os-place-order.component').then(
						(c) => c.OsPlaceOrderComponent,
					),
			},
			{
				title: 'EOP - My Orders',
				path: ROUTE_PATH.myOrders,
				canMatch: [accessGuard],
				data: {
					config: 'os',
					access: {
						permissions: ['CanViewOrders'],
					},
					link: { svgIcon: 'cust-lens-check', text: 'My orders' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/my-orders/_os-my-orders/os-my-orders.component').then(
						(c) => c.OsMyOrdersComponent,
					),
			},
			{
				title: 'EOP - Order Lenses',
				path: ROUTE_PATH.placeOrder,
				canMatch: [accessGuard],
				data: {
					config: 'dop',
					access: {
						roles: ['roleDopUser'],
						permissions: ['CanCreateOrders'],
					},
					link: { svgIcon: 'cust-lens-add', text: 'Place a lens order' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/place-order/_dop-place-order/dop-place-order.component').then(
						(c) => c.DopPlaceOrderComponent,
					),
			},
			{
				title: 'EOP - My Orders',
				path: ROUTE_PATH.myOrders,
				canMatch: [accessGuard],
				data: {
					config: 'dop',
					access: {
						roles: ['roleDopUser'],
						permissions: ['CanViewOrders'],
					},
					link: { svgIcon: 'cust-lens-check', text: 'My orders' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/my-orders/_dop-my-orders/dop-my-orders.component').then(
						(c) => c.DopMyOrdersComponent,
					),
			},
			{
				title: 'EOP - Organization Orders',
				path: ROUTE_PATH.organizationOrders,
				canMatch: [accessGuard],
				data: {
					access: {
						permissions: ['CanViewOrganizationOrders'],
					},
					link: { svgIcon: 'cust-lens-check-all', text: 'Organization orders' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/organization-orders/organization-orders.component').then(
						(c) => c.OrganizationOrdersComponent,
					),
			},
			{
				title: 'EOP - All Orders',
				path: ROUTE_PATH.allOrders,
				canMatch: [accessGuard],
				data: {
					access: {
						permissions: ['CanViewAllOrders'],
					},
					link: { svgIcon: 'cust-lens-check-all-2', text: 'All orders' },
					showInMenu: true,
				},
				loadComponent: () =>
					import('./features/all-orders/all-orders.component').then((c) => c.AllOrdersComponent),
			},
		],
	},
	{
		title: 'EOP - Sign In',
		path: ROUTE_PATH.signIn,
		loadComponent: () =>
			import('./features/sign-in/sign-in.component').then((c) => c.SignInComponent),
	},
	{
		title: 'EOP - Terms',
		path: ROUTE_PATH.terms,
		loadComponent: () => import('./features/terms/terms.component').then((c) => c.TermsComponent),
	},
	{
		title: 'EOP - Terms Processing',
		path: ROUTE_PATH.termsPending,
		loadComponent: () =>
			import('./features/terms-pending/terms-pending.component').then(
				(c) => c.TermsPendingComponent,
			),
	},
	{
		title: 'EOP - Sign Out',
		path: ROUTE_PATH.signOut,
		loadComponent: () =>
			import('./features/sign-out/sign-out.component').then((c) => c.SignOutComponent),
	},
	{
		path: '**',
		redirectTo: '',
	},
];

export const routes: EopRoute[] = environment.appMeta.maintenanceMode
	? maintenanceRoutes
	: mainRoutes;
